import { render } from "./ResultsPage.vue?vue&type=template&id=27f72f4b&ts=true"
import script from "./ResultsPage.vue?vue&type=script&lang=ts"
export * from "./ResultsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__